import React from 'react'
import { Link } from 'react-router-dom'
const LmSection_1 = () => {
    return (
        <div className="container">
            <div className="text-center px-20">
                <div className="section-heading">
                    <div className="title-wrapper">
                        <h2 className="section-title has_fade_anim fs-4x  text-grad-1 pb-6">
                            Language Models – LLMs, SLMs
                        </h2>
                    </div>
                    <div className="text-wrapper mt-0">
                        <p className="text has_fade_anim mt-3 fs-1  text-grad-3">
                            Language models that work for you!
                        </p>
                    </div>
                    <div className="btn-wrap has_fade_anim mt-10">
                        <Link to="#how-do-we-do-it" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 me-5 fs-4">
                            <span data-text="How we do it?">How we do it?</span>
                        </Link>
                        <Link to="#domain-context" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 me-5 fs-4">
                            <span data-text="Domain & Context">Domain & Context
                            </span>
                        </Link>
                        <Link to="#cost-effective" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 fs-4 me-5">
                            <span data-text="Energy efficiency">Energy efficiency
                            </span>
                        </Link>
                        <Link to="#llms" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 fs-4">
                            <span data-text="Custom-built LLMs">Custom-built LLMs 
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export {LmSection_1}